<template>
    <v-row row justify-center>
        <v-dialog persistent transition="scale-transition" max-width="500" v-model="dialogModel">
            <v-card>
                <v-toolbar dark dense color="red" card>
                    <v-toolbar-title>Trial expired!</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-sheet color="white">
                    <v-img :src="cdnBaseUrl('/img/sample_ninja_app_email_header.png')"></v-img>
                </v-sheet>
                <v-card-text class="pt-4">
                    Your trial has expired! Please contact us at sales@sampleninja.io to extend your trial or buy a license!
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" class="ml-2 mb-2" @click="sendEmail">Contact us</v-btn>
                    <v-btn color="primary" class="ml-2 mb-2" @click="visitWebsite">Visit website</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

export default {
    data: function () {
        return {
            dialogModel: true
        }
    },

    methods: {
        sendEmail() {
            window.location.href = "mailto:sales@sampleninja.io";
        },
        visitWebsite() {
            this.sendToUrl('http://www.sampleninja.io');
        }
    }
}
</script>

